import { PageHero } from '@/components/ui/PageHero'
import { herbalWalkGroup } from '@/assets/siteMedia'

export const CoursesHero = () => (
  <PageHero
    image={herbalWalkGroup}
    imageAlt="Kandake teaching a group about plants outdoors"
    highlights={['Courses & workshops', 'Herbal walks', 'Community education']}
    title="Courses &"
    accent="Workshops"
    description={
      <p>
        Transformational learning journeys, not just information sessions. Each programme empowers
        you with practical knowledge, deeper body awareness, and reconnection to nature and
        traditional wisdom.
      </p>
    }
  />
)
